// MUI-free copy of Ui-components/SocialMedia.
import {memo, useCallback} from 'react';
import {MobileNumber} from '@/constants';
import styles from './SocialMedia.module.scss';

interface SocialMediaProps {
    className?: string;
}

const WHATSAPP_TEXT = 'Hi!%20I%20want%20to%20talk%20about%20your%20services%20and%20products.';
const WHATSAPP_MOBILE = `https://wa.me/${MobileNumber}?text=${WHATSAPP_TEXT}`;
const WHATSAPP_DESKTOP = `https://web.whatsapp.com/send?phone=${MobileNumber}&text=${WHATSAPP_TEXT}`;
// The original read useMediaQuery('(max-width:480px)'); checking at click time gives the same link without a re-render.
const MOBILE_QUERY = '(max-width:480px)';

const SocialMedia = ({className}: SocialMediaProps) => {
    const handleWhatsapp = useCallback(() => {
        const url = globalThis.matchMedia(MOBILE_QUERY).matches ? WHATSAPP_MOBILE : WHATSAPP_DESKTOP;
        globalThis.open(url, '_blank');
    }, []);

    return (
        <div className={className ? `${styles.wrapper} ${className}` : styles.wrapper}>
            <button type="button" onClick={handleWhatsapp} className={`animated-button ${styles.button}`} aria-label="Connect on Whatsapp">
                Connect on Whatsapp
            </button>
        </div>
    );
};

export default memo(SocialMedia);
